import { render } from "./IncomeVsSpendChart.vue?vue&type=template&id=45c30a0c&scoped=true"
import script from "./IncomeVsSpendChart.vue?vue&type=script&lang=js"
export * from "./IncomeVsSpendChart.vue?vue&type=script&lang=js"

import "./IncomeVsSpendChart.vue?vue&type=style&index=0&id=45c30a0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c30a0c"]])

export default __exports__